import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from '../../context/router-context';
import { useHomeOrganizationsQuery } from '../../__generated__/graphql';
import OrganizationsTileUI from './OrganizationsTileUI';
export default function OrganizationsTileData() {
    // Router
    var goForwardClick = useRouter().goForwardClick;
    // GraphQL query
    var _a = useHomeOrganizationsQuery(), data = _a.data, loading = _a.loading;
    var organizations = data && data.organizations;
    return (_jsx(OrganizationsTileUI, { loading: loading, organizations: organizations || [], organizationsClick: goForwardClick("/organizations"), organizationClick: function (id) { return goForwardClick("/organizations/" + id)(); } }, void 0));
}
//# sourceMappingURL=OrganizationsTileData.js.map